import { createFileRoute } from "@tanstack/react-router"
import CreateSupportRequestPage from "@/components/coreSupportRequests/CreateSupportRequestPage"

export const Route = createFileRoute("/core/support-requests/create")({
  component: CreateSupportRequestPage
})
